import {
  Component,
  EventEmitter,
  inject,
  Output,
  ViewEncapsulation,
} from '@angular/core';

import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { Observable } from 'rxjs';

import { ThemeService, UsersService } from '@ose/services';

import { ThemeMode } from '@ose/types';

import { LanguageSwitchComponent, ThemeModeSwitchComponent } from '@ose/ui';

@Component({
  selector: 'app-aside',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    LanguageSwitchComponent,
    ThemeModeSwitchComponent,
  ],
  templateUrl: './aside.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class AsideComponent {
  @Output()
  readonly linkClick = new EventEmitter<void>();

  private readonly themeService = inject(ThemeService);

  private readonly usersService = inject(UsersService);

  protected readonly themeMode$: Observable<ThemeMode> =
    this.themeService.getThemeMode();

  protected readonly activeLinkClasses = [
    'bg-body-tertiary',
    'text-body-emphasis',
    'fw-bold',
    'opacity-100',
    'shadow-sm',
  ];

  readonly hasCards = toSignal(this.usersService.hasConfirmedCards(), {
    initialValue: false,
  });

  onLinkClick(): void {
    this.linkClick.emit();
  }
}
